<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content create-alert-form">
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <div
    class="scroll-wrapper ui basic segment"
    style="padding: 0"
    [ngClass]="{ loading: pending }"
  >
    <div class="ui form" [formGroup]="fileUploadForm">
      <div *ngIf="data?.fileSettingsId === 'file_size_configuration'">
        <div class="field section" [ngClass]="displayFieldCss('imageMaxSize')">
          <label class="required"
            >Image Maximum File Size <span>(Size is in bytes(B))</span></label
          >
          <input
            formControlName="imageMaxSize"
            placeholder="Enter image max file size"
          />
          <app-field-error-display
            [displayError]="isFieldValid('imageMaxSize')"
            errorMsg="Please enter image max file size"
          >
          </app-field-error-display>
        </div>

        <div class="field section" [ngClass]="displayFieldCss('videoMaxSize')">
          <label class="required"
            >Video Maximum File Size <span>(Size is in bytes(B))</span></label
          >
          <input
            formControlName="videoMaxSize"
            placeholder="Enter video max file size"
          />
          <app-field-error-display
            [displayError]="isFieldValid('videoMaxSize')"
            errorMsg="Please enter video max file size"
          >
          </app-field-error-display>
        </div>

        <div
          class="field section"
          [ngClass]="displayFieldCss('documentMaxSize')"
        >
          <label class="required"
            >Document Maximum File Size
            <span>(Size is in bytes(B))</span></label
          >
          <input
            formControlName="documentMaxSize"
            placeholder="Enter document max file size"
          />
          <app-field-error-display
            [displayError]="isFieldValid('documentMaxSize')"
            errorMsg="Please enter document max file size"
          >
          </app-field-error-display>
        </div>

        <div class="field section" [ngClass]="displayFieldCss('otherMaxSize')">
          <label class="required"
            >Other Maximum File Size <span>(Size is in bytes(B))</span></label
          >
          <input
            formControlName="otherMaxSize"
            placeholder="Enter other max file size"
          />
          <app-field-error-display
            [displayError]="isFieldValid('otherMaxSize')"
            errorMsg="Please enter other max file size"
          >
          </app-field-error-display>
        </div>
      </div>

      <div *ngIf="data?.fileSettingsId === 'allowed_file_types'">
        <!-- <p class="title-text">Files Exceeding Recommended Limit</p> -->
        <!-- <mat-divider></mat-divider> -->

        <div
          class="field section"
          [ngClass]="displayFieldCss('imageFileTypes')"
        >
          <label class="required"
            >Image File Types
            <span
              >(Enter as many extension as you want and separate with a comma
              (e.g: .svg))</span
            ></label
          >
          <input
            formControlName="imageFileTypes"
            placeholder="Enter imageFileTypes"
          />
          <app-field-error-display
            [displayError]="isFieldValid('imageFileTypes')"
            errorMsg="Please enter imageFileTypes"
          >
          </app-field-error-display>
        </div>

        <div
          class="field section"
          [ngClass]="displayFieldCss('videoFileTypes')"
        >
          <label class="required"
            >Video File Types
            <span
              >(Enter as many extension as you want and separate with a comma
              (e.g: .svg))</span
            ></label
          >
          <input
            formControlName="videoFileTypes"
            placeholder="Enter video file type"
          />
          <app-field-error-display
            [displayError]="isFieldValid('videoFileTypes')"
            errorMsg="Please enter video file type"
          >
          </app-field-error-display>
        </div>

        <div
          class="field section"
          [ngClass]="displayFieldCss('documentFileTypes')"
        >
          <label class="required"
            >Document File Type
            <span
              >(Enter as many extension as you want and separate with a comma
              (e.g: .svg))</span
            ></label
          >
          <input
            formControlName="documentFileTypes"
            placeholder="Enter document file type"
          />
          <app-field-error-display
            [displayError]="isFieldValid('documentFileTypes')"
            errorMsg="Please enter document file type"
          >
          </app-field-error-display>
        </div>

        <div
          class="field section"
          [ngClass]="displayFieldCss('otherFileTypes')"
        >
          <label class="required"
            >Other File Type
            <span
              >(Enter as many extension as you want and separate with a comma
              (e.g: .svg))</span
            ></label
          >
          <input
            formControlName="otherFileTypes"
            placeholder="Enter other file type"
          />
          <app-field-error-display
            [displayError]="isFieldValid('otherFileTypes')"
            errorMsg="Please enter other file type"
          >
          </app-field-error-display>
        </div>
      </div>

      <div *ngIf="data?.fileSettingsId === 'file_upload_response'">
        <p class="title-text">Files Exceeding Recommended Limit</p>
        <mat-divider></mat-divider>

        <div
          class="field section"
          [ngClass]="displayFieldCss('maxFileSizeExceeded')"
        >
          <label class="required">Maximum File Size Exceeded</label>
          <input
            formControlName="maxFileSizeExceeded"
            placeholder="Enter file size exceeded"
          />
          <app-field-error-display
            [displayError]="isFieldValid('maxFileSizeExceeded')"
            errorMsg="Please enter file size exceeded"
          >
          </app-field-error-display>
        </div>

        <div
          class="field section"
          [ngClass]="displayFieldCss('unallowedFileType')"
        >
          <label class="required">Unallowed File Type</label>
          <input
            formControlName="unallowedFileType"
            placeholder="Enter unallowed file type"
          />
          <app-field-error-display
            [displayError]="isFieldValid('unallowedFileType')"
            errorMsg="Please enter unallowed file type"
          >
          </app-field-error-display>
        </div>
      </div>

      <div *ngIf="data?.fileSettingsId === 'file_concurrent_uploads'">
        <div class="field section" [ngClass]="displayFieldCss('count')">
          <label class="required"
            >Simultaneous file uploads per user session</label
          >

          <input
            formControlName="count"
            type="number"
            placeholder="Enter count"
          />
          <app-field-error-display
            [displayError]="isFieldValid('count')"
            errorMsg="Please enter count"
          >
          </app-field-error-display>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="actions" style="border: none; background-color: #fff">
  <button class="ui button cancel-modal" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [disabled]="!fileUploadForm.valid"
    (click)="save()"
    [ngClass]="{ 'yellow loading': pending }"
    autofocus
  >
    Save
  </button>
</div>
